// Framework
import { Component } from '@angular/core'
import { NavigationEnd } from '@angular/router'

@Component({
  selector: 'app-header-login',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class AppHeaderLoginComponent {
  navigateToCandidate() {
    window.location.href = 'https://network.cnected.com/'
  }
}
